import React from 'react';
import PropTypes from 'prop-types';
import Skeleton from '~components/skeleton';
import { iconArrow } from '~utils/svgIcons';
import '~components/select/style.scss';
import '../style.scss';
import './style.scss';

function NotificationSettingsLoader({ isMobile }) {
    return (
        <div className="notification-settings notification-settings-loader">
            <form>
                <h3>
                    <Skeleton
                        width={isMobile ? 220 : 290}
                        fontSize={isMobile ? 18 : 24}
                        lineHeight={isMobile ? 23.96 : 40}
                    />
                </h3>
                <div className="notification-settings__select-group">
                    <div className="notification-settings__select-wrap">
                        <div className="select">
                            <div className="select__wrap">
                                <Skeleton
                                    width={isMobile ? 135 : 180}
                                    fontSize={isMobile ? 16 : 16}
                                    lineHeight={isMobile ? 24 : 24}
                                />
                                <span className="select__arrow-icon">{iconArrow('#C31B1C')}</span>
                                <span className="select__label">Период отправки</span>
                            </div>
                            <span className="select__error">Период отправки</span>
                        </div>
                    </div>
                    <div className="notification-settings__select-wrap">
                        <div className="select">
                            <div className="select__wrap">
                                <Skeleton
                                    width={isMobile ? 185 : 180}
                                    fontSize={isMobile ? 16 : 16}
                                    lineHeight={isMobile ? 24 : 24}
                                />
                                <span className="select__arrow-icon">{iconArrow('#C31B1C')}</span>
                                <span className="select__label">Время</span>
                            </div>
                            <span className="select__error">Время</span>
                        </div>
                    </div>
                </div>
                <div className="notification-settings__head">
                    <div className="notification-settings__event">
                        <span>Событие</span>
                    </div>
                    <div className="notification-settings__email">
                        <span>Email</span>
                    </div>
                </div>
                <div className="notification-settings__check-group">
                    <div className="notification-settings__event">
                        <span className="notification-settings__event-title">Избранные документы пользователей</span>
                    </div>
                    <div className="notification-settings__email">
                        <Skeleton width={isMobile ? 44 : 58} fontSize={isMobile ? 25 : 32} borderRadius={16} />
                    </div>
                </div>

                <div className="notification-settings__check-group">
                    <div className="notification-settings__event">
                        <span className="notification-settings__event-title">Рекомендованные системой как "Важно"</span>
                    </div>
                    <div className="notification-settings__email">
                        <Skeleton width={isMobile ? 44 : 58} fontSize={isMobile ? 25 : 32} borderRadius={16} />
                    </div>
                </div>
            </form>
        </div>
    );
}

NotificationSettingsLoader.propTypes = {
    isMobile: PropTypes.bool.isRequired,
};

export default NotificationSettingsLoader;
export { NotificationSettingsLoader };



// WEBPACK FOOTER //
// ./src/routes/main/userprofile/tab-settings/notification-settings/loader/index.js